export default function ProblemsViewComponent() {
    return (
        <section className="py-16 px-2">
            <div className="max-w-4xl mx-auto">

                {/* Header */}
                <div className="text-center mb-12">
                    <p className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-3">
                        For families who've done everything right
                    </p>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                        Your kid checks every box.<br />So do 50,000 other applicants.
                    </h2>
                    <p className="text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
                        The right schools, the right tutors, the right extracurriculars, and still, something is missing. Admissions committees and first employers aren't just counting credentials anymore. They're looking for one thing: evidence that your child can actually <em>do</em> something.
                    </p>
                </div>

                {/* Problem cards */}
                <div className="grid grid-cols-2 gap-1 md:gap-4 mb-8">
                    <ProblemCard
                        label="The credential ceiling"
                        description="Private school. Test prep. AP classes. At a certain level, everyone has these. They no longer differentiate. They just qualify."
                    />
                    <ProblemCard
                        label="The internship illusion"
                        description="Access isn't the same as experience. A high achiever can land the internship, but observing from the sidelines doesn't teach a person how to build something real, lead a team, or ship a product that people actually use."
                    />
                    <ProblemCard
                        label="The essay problem"
                        description="The best college counselor in the world can sharpen a student's essay, tighten the framing, and make every word land. What they can't do is give a student something worth writing about. Polish only goes so far; when there's no real experience underneath it, the most carefully crafted application still blends into the thousands that read just like it."
                    />
                    <ProblemCard
                        label="The camp circuit"
                        description="Leadership programs. Entrepreneurship camps. Model UN. These look impressive on paper, but admissions readers have seen thousands of them. Certificates aren't outcomes."
                    />
                </div>

                {/* Insight callout */}
                <div className="bg-gray-50 border border-gray-100 rounded-2xl p-6 flex gap-4 items-start">
                    <div className="flex-shrink-0 w-9 h-9 rounded-full bg-blue-50 flex items-center justify-center text-blue-500 text-sm font-bold">
                        i
                    </div>
                    <div>
                        <p className="font-semibold text-gray-900 text-sm mb-1">
                            What top colleges and employers are actually looking for
                        </p>
                        <p className="text-sm text-gray-500 leading-relaxed">
                            Proof of execution. A student who conceived something, took ownership, encountered real obstacles, and shipped it anyway. That story, backed by a live product and a recommendation from a founder who actually knows their work, is the differentiator.
                        </p>
                    </div>
                </div>

            </div>
        </section>
    );
}

const ProblemCard = ({ label, description }) => (
    <div className="bg-white border border-gray-100 rounded-xl p-5 hover:border-gray-200 hover:shadow-sm transition-all duration-200">
        <p className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-2">{label}</p>
        <p className="text-sm text-gray-700 leading-relaxed">{description}</p>
    </div>
);